<script>
    import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
    Table,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    FormGroup,
    Label,
    Collapse,
    CardHeader,
    CardTitle,
    CardBody,
    CardText,
  } from "sveltestrap";

  import { functionImpl } from '../../shared/expressions';
export let addColOpen;
export let data;
export let editName;
let expr = null;
export let done;

let addName;
let exprFeedback=""
let minFeedback=""
let maxFeedback=""
let exprClass="exprOK"
let colsRef = "";
let type = "";
// let funcs=[];
let sampleEvals=[]
$: {
  let ast; 
  try {
    exprFeedback=""
    ast = jsep(expr);
    exprClass = "exprOK"

    // const walk=(n,cols,funcs) => {
    //   switch (n.type) {
    //     case "Identifier": { 
    //       cols.push(n.name)
    //       break
    //     }
    //     case "BinaryExpression": {
    //       walk(n.left,cols,funcs);
    //       walk(n.right,cols,funcs);
    //       break
    //     }
    //     case "CallExpression": {
    //       funcs.push(n.callee.name) // XXX verify type == Identifier
    //       n.arguments.forEach(a=>walk(a, cols,funcs));
    //       break
    //     }
    //   }
    // }

    // var cols = []
    // walk(ast, cols, funcs)
    // colsRef = JSON.stringify(cols);

  } catch(ex) {
    exprClass = "exprError"
    exprFeedback = ex.message
  }

  // console.log("data", data)

  if (data.instances.length) {
    const state={};
    sampleEvals = data.instances[0].columns[0].sample.map((_,i)=>{
      let result = "";
      let error = "";
      try {
        let sample = data.instances[0].columns.reduce((obj,col)=>(obj[col.name]=col.sample[i],obj),{})
        let context = {...sample,...functionImpl, state}
        minFeedback = ""
        result = evaluateTerminal(expr, context);
        type = typeof sampleEvals.shift().result == "number" ? "number":"text";
        // window.result = result;
        // window.ast = ast;
      } catch (ex) {
        error = ex.message
      }
      return {result,error}
    })
  }
  else {
    console.log("no instances", data)
  }
}

if (editName) {
  addName = editName;
  expr = data.instances[0].columns.filter(col => col.name == editName).shift().expr;
}

$: {
  if (!addColOpen) {
    done();
  }
}

function addColumn() {
  data.instances[0].columns = [{
    name:addName, 
    sample:sampleEvals.map(ev=>ev.result),
    expr,
    type,
  }, ...data.instances[0].columns]
  close()
}

function saveColumn() {
  data.instances[0].columns = data.instances[0].columns.map(col => col.name == addName ? {
    ...col, 
    sample:sampleEvals.map(ev=>ev.result),
    expr, 
    type,
  }: col)
  close()
}

function removeColumn() {
  data.instances[0].columns = data.instances[0].columns.filter(col => col.name != addName);
  close()
}

function close() {
  addName = "";
  expr=null;
  addColOpen = false;
}

</script>
<style>
.exprOK { color:    var(--gray) }
.exprError { color: var(--danger); }
.example { padding: 0.5rem; border: 1px solid gray; margin-left: 5rem; margin-bottom: 0.5rem; border-top-right-radius: 5px;}





.addcolgroup > .inputPrefix {
    width: 7rem;
}

.addcolgroup  {
  padding-bottom: 1rem;
}

.addcolgroup .input-group {
  background-color: cadetblue;
}

.addcolgroup.modal-body { padding: 1rem; }

</style>

<Modal isOpen={addColOpen} toggle={()=>(addColOpen=!addColOpen)} class="modal-lg" >
    <ModalHeader >Edit column
    </ModalHeader>
    <ModalBody>
      <div class="addcolgroup">
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>Name</InputGroupText>
        </InputGroupAddon>
        <Input bind:value={addName} readonly={!!editName} />
      </InputGroup>
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>Expression</InputGroupText>
        </InputGroupAddon>
        <Input bind:value={expr}  />
      </InputGroup>
          <!-- <FormGroup>
        <Label for="">Name:</Label><input type=text name=addName bind:value={addName}>
      </FormGroup> -->
      <!-- <FormGroup>
        <Label for="">Expression:</Label><textarea name=expr bind:value={expr}></textarea>
      </FormGroup> -->
      <div class="{exprClass}" >{exprFeedback}</div>
      {#each sampleEvals as ev}
        <div class="example" >{ev.result || ev.error}</div>
      {/each}
      </div>
    </ModalBody>
    <ModalFooter>
      <div class=container>
        <div class=row>
          <div class=col-auto>
            <Button color="danger" on:click={removeColumn}>Remove</Button>
          </div>
          <div class=col>
            {#if editName}
            <Button color="primary" on:click={saveColumn}>Save</Button>
            {:else}
            <Button color="primary" on:click={addColumn}>Add</Button>
            {/if}
            <Button color="primary" on:click={close}>Cancel</Button>
          </div>
        </div>
      </div>
    </ModalFooter>
  </Modal>
